// extracted by mini-css-extract-plugin
module.exports = {"wrap":"NavBar_wrap__1DE6T","search":"NavBar_search__1n4t4"};